if (!customElements.get('bd-product-total')) {
  customElements.define('bd-product-total', class extends HTMLElement {
    connectedCallback() {
      this.host = this.closest('product-info');
      if (!this.host || typeof subscribe !== 'function') return;
      this.pending = false;
      this.onQuantity = (event) => {
        if (event.target.matches('[name="quantity"]')) this.update();
      };
      this.onOption = (event) => {
        if (event.target.closest('variant-selects')) {
          this.pending = true;
          this.hideTotal();
        }
      };
      this.host.addEventListener('input', this.onQuantity);
      this.host.addEventListener('change', this.onQuantity);
      this.host.addEventListener('change', this.onOption, true);
      this.unsubOption = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (this.host.contains(data.event.target)) {
          this.pending = true;
          this.hideTotal();
        }
      });
      this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== String(this.host.dataset.originalSection || this.host.dataset.section)) return;
        const source = data.html.getElementById('BdTotal-' + data.sectionId);
        if (!source) { this.hideTotal(); return; }
        Object.assign(this.dataset, source.dataset);
        this.pending = false;
        this.update();
      });
      this.unsubQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.update());
      this.update();
    }
    disconnectedCallback() {
      this.host?.removeEventListener('input', this.onQuantity);
      this.host?.removeEventListener('change', this.onQuantity);
      this.host?.removeEventListener('change', this.onOption, true);
      this.unsubOption?.();
      this.unsubVariant?.();
      this.unsubQuantity?.();
    }
    get button() {
      return this.closest('form')?.querySelector('button[name="add"]');
    }
    hideTotal() {
      this.hidden = true;
      const button = this.button;
      if (button && (this.pending || !button.disabled) && !button.classList.contains('loading')) {
        button.querySelector('span').textContent = window.variantStrings.addToCart;
      }
    }
    update() {
      const form = this.closest('form');
      const quantityInput = this.host.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? Number(quantityInput.value) : 1;
      const variantId = form?.querySelector('[name="id"]')?.value;
      const price = Number(this.dataset.price);
      const button = this.button;
      if (this.pending || this.dataset.unsupported === 'true' ||
          this.dataset.available !== 'true' || variantId !== this.dataset.variant ||
          !Number.isInteger(quantity) || quantity < 1 || (quantityInput && !quantityInput.checkValidity()) ||
          !Number.isSafeInteger(price) || price < 0 || !Number.isSafeInteger(price * quantity) ||
          !button || button.disabled) {
        this.hideTotal();
        return;
      }
      let amount;
      try {
        amount = new Intl.NumberFormat(this.dataset.locale, {
          style: 'currency', currency: this.dataset.currency,
          minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(price * quantity / 100);
      } catch { this.hideTotal(); return; }
      const unit = this.dataset.unit.replace(/^\s*\/\s*/, '').toLowerCase();
      const suffix = /^(stk\.?|styk|stykker)$/.test(unit) ? this.dataset.piece :
        /^(pakke|pakker|pack|packs)$/.test(unit) ? (quantity === 1 ? this.dataset.pack : this.dataset.packs) : '';
      const count = String(quantity) + (suffix ? ' ' + suffix : '');
      if (!button.classList.contains('loading') && button.getAttribute('aria-disabled') !== 'true') {
        button.querySelector('span').textContent = this.dataset.button.replace('[quantity]', count).replace('[total]', amount);
      }
    }
  });
}
